import { render } from "./AdminPublic.vue?vue&type=template&id=4457a018&scoped=true"
import script from "./AdminPublic.vue?vue&type=script&lang=js"
export * from "./AdminPublic.vue?vue&type=script&lang=js"

import "./AdminPublic.vue?vue&type=style&index=0&id=4457a018&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4457a018"]])

export default __exports__